let items = document.querySelectorAll(".result-wrap");
for (let item of items) {
  setInterval(function () {
    let currentValue = (Math.round((parseFloat(item.dataset.current) +  parseFloat(item.dataset.value) + Number.EPSILON) * 100) / 100);
    item.dataset.current = currentValue;
    item.textContent = currentValue.toLocaleString("de-DE");
  }, 1000);
}
